import Vue from 'vue'
import subsidies from './index.vue'
Vue.component('select-subsidies', subsidies);
